import { ENDPOINTS_MANAGER } from 'common/endpoints/vacations-absences.endpoints';

class teamRequestsService {
  constructor($http, teamRequestsFormatters) {
    'ngInject';
    this.http = $http;
    this.formatters = teamRequestsFormatters;
  }

  getRequests(managerId) {
    return this.http.get(ENDPOINTS_MANAGER.get.requests(managerId)).then(response => {
      return response.data;
    });
  }

  reject(managerId, request) {
    let params = this.formatters.formatReject(request);

    return this.http.put(ENDPOINTS_MANAGER.put.requests(managerId), params).then(response => {
      return response.data;
    });
  }

  approveAll(managerId, requests) {
    let params = this.formatters.formatApproveAll(requests);
    return this.http.put(ENDPOINTS_MANAGER.put.requests(managerId), params).then(response => {
      return response.data;
    });
  }

  approve(managerId, request) {
    let params = this.formatters.formatApprove(request);

    return this.http.put(ENDPOINTS_MANAGER.put.requests(managerId), params).then(response => {
      return response.data;
    });
  }

  discard(managerId, request) {
    let params = this.formatters.formatDiscard(request);

    return this.http.put(ENDPOINTS_MANAGER.put.discardRequest(managerId), params).then(response => {
      return response.data;
    });
  }

  getCoincidences(managerId, startDate, endDate) {
    let data = {
      params: {
        'filter_start_date' : startDate ,
        'filter_end_date' : endDate
      }
    };

    return this.http.get(ENDPOINTS_MANAGER.get.coincidences(managerId), data).then(response => {
      return response.data;
    });
  }
}

export default teamRequestsService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.service.js